import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';

import {Wrapper, Paragraph, Ok} from '../Modal/modal.style';

export class RestaurantClosedModal extends PureComponent {
  render() {
    const {closeModalCallback} = this.props;

    return (
      <Wrapper>
        <Paragraph>
          <FormattedMessage id="checkout.restaurantClosedModalDescriptionL1" /><br />
          <FormattedMessage
            id="checkout.restaurantClosedModalDescriptionL2"
            values={{
              link: (
                <Link
                  to="/contact"
                >
                  <FormattedMessage id="checkout.here" />
                </Link>
              )
            }}
          />
        </Paragraph>
        <Ok onClick={closeModalCallback}><FormattedMessage id="modal.ok" /></Ok>
      </Wrapper>
    );
  }
}

RestaurantClosedModal.propTypes = {
  closeModalCallback: PropTypes.func
};

export default RestaurantClosedModal;



// WEBPACK FOOTER //
// ./components/RestaurantClosedModal/RestaurantClosedModal.js